<template>
  <div v-if="profile" class="" style="height: 100%;">
    <dialog-add-business v-if="me" ref="dialogAddBusiness" :is_business="me.company_type == 'agency' ? false : true"></dialog-add-business>

    <div v-if="show_submit_lsa_cid" @click.self="show_submit_lsa_cid = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          Submit Google LSA CID

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_submit_lsa_cid = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full mb-3'">
              <div v-if="!me.lsa_command_enabled">
                <product-access-required product="lsa_command" />
              </div>
              <div v-else>
                <p class="mb-1 text-xs mb-2"><strong>CID</strong></p>
                <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="lsa_cid" style="padding-right: 35px !important;" :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                />

                <p class="text-xs text-gray-600 pt-2">
                  Submit your LSA CID in order for us to start your survey/refund process.
                </p>

                <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-4 mt-1" role="alert">
                  <div>To ensure the LSA Command performs properly, please verify that your client's CID is connected to both your MCC and our MCC.</div>
                  <div>Watch this tutorial first:</div>

                  <div style="position: relative; padding-bottom: 58.06451612903225%; height: 0;"><iframe src="https://www.loom.com/embed/e1da634be5cc464e9aa8b426f0b7ba59" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button v-show="me.lsa_command_enabled" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" @click="saveLsaCid()">
              SUBMIT
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_submit_lsa_cid = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <v-app-bar v-if="showHeaderAndNav" app color="" class="header-top" elevation="0" v-on-clickaway="clickedOutsideUserMenu"
    
      :style="(($vuetify.breakpoint.mobile) ? 'left: 0px; z-index: 9;' : '')"
    
    >
      <!-- <i class="fa fa-chart-bar" style="font-size: 30px; cursor: pointer;"></i> -->
      <v-app-bar-nav-icon v-if="!$vuetify.breakpoint.mobile" @click.stop="sidebarMenu = !sidebarMenu"></v-app-bar-nav-icon>
      
      <div class="flex flex-row items-center justify-between flex-wrap mt-1" style="min-height: 60px;" v-on-clickaway="clickedOutsideLocationsDd">
        <div class="header-right-part">

          <div class="relative">
            <br clear="all" />
              <template v-if="me && !$store.state.auth.is_location">
                <div class="header-right-items">

                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    hide-details
                    v-model="search_locations"
                    class="locations-dropdown"
                    outlined
                    dense
                    @focus="showLocationsDd();"
                    @keyup="calculateFilteredLocations()"
                  >
                    
                  </v-text-field>

                  <div v-show="show_locations_dd" style="position: absolute; padding: 20px; background: #FFFFFF; border-radius: 10px; max-width: 100%; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)">
                    <div v-if="profile">
                      <div class="locations-links" v-if="me.company_type != 'agency'">
                        <router-link to="/locations" @click="show_locations_dd = false" style="font-size: 12px;"><i class="mdi mdi-map-marker"></i> Manage Locations</router-link>
                        &nbsp;&nbsp;&nbsp;
                        <a href="javascript: void(0);" style="font-size: 12px;" @click="show_locations_dd = false; $refs.dialogAddBusiness.show()"><i class="fa fa-plus"></i> Add Location for this business</a>
                      </div>

                      <div v-if="me.company_type == 'agency'" class="locations-links">
                        <router-link to="/businesses" @click="show_locations_dd = false" style="font-size: 12px;" v-if="sectionEnabled('/businesses')"><i class="mdi mdi-map-marker"></i> View All Businesses</router-link>
                        &nbsp;&nbsp;&nbsp;
                        <a href="javascript: void(0);" style="font-size: 12px;" @click="show_locations_dd = false; $refs.dialogAddBusiness.show()" v-if="profile.settings.role != 'Manager (readonly)'"><i class="fa fa-plus"></i> Add Business</a>
                      </div>
                    </div>

                    <template>
                      <div style="max-height: 350px; overflow: auto;">
                        <div v-for="(item, index) in filtered_locations" :key="'location-' + index">
                          <a href="javascript: void(0);" @click="switchLocation(item.value)" :style="((me.uuid == item.value && 0) ? '' : 'color: #000000 !important;')">
                            <template v-if="me.company_type == 'admin'">
                              <template v-if="item.type == 'agency'">
                                <strong style='font-size: 16px;' v-html="'<i class=\'fa fa-building\'></i>&nbsp; ' + item.name"></strong>
                              </template>
                              <template v-if="item.type == 'business'">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                              <template v-if="item.type == 'location'">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                            </template>

                            <template v-if="me.company_type == 'agency'">
                              <template v-if="item.type == 'business'">
                                <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                              <template v-if="item.type == 'location'">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                            </template>

                            <template v-if="me.company_type == 'business' || me.company_type == 'location'">
                              <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                            </template>
                          </a>
                        </div>
                      </div>
                    </template>
                  </div>

                  <v-combobox
                    v-if="!fetchingLocations && !fetchingStats && 0"
                    v-model="me.uuid"
                    label=""
                    :items="locations"
                    item-text="name"
                    item-value="value"
                    hide-no-data
                    return-object
                    outlined
                    dense
                    hide-details
                    @change="switchLocation(me.uuid)"
                    class="locations-dropdown"
                    prepend-inner-icon="mdi-magnify"
                    append-icon="mdi-chevron-down"
                    @click="checkLocationsLinksDone()"
                  >
                    <template v-slot:item="{ item }">
                      <template v-if="me.company_type == 'admin'">
                        <template v-if="item.type == 'agency'">
                          <strong style='font-size: 16px;' v-html="'<i class=\'fa fa-building\'></i>&nbsp; ' + item.name"></strong>
                        </template>
                        <template v-if="item.type == 'business'">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name"></span>
                        </template>
                        <template v-if="item.type == 'location'">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name"></span>
                        </template>
                      </template>

                      <template v-if="me.company_type == 'agency'">
                        <template v-if="item.type == 'business'">
                          <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name"></span>
                        </template>
                        <template v-if="item.type == 'location'">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name"></span>
                        </template>
                      </template>

                      <template v-if="me.company_type == 'business' || me.company_type == 'location'">
                        <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name"></span>
                      </template>
                    </template>
                  </v-combobox>

                  <div v-if="fetchingLocations || fetchingStats" style="">
                    <i class="fa fa-spin fa-spinner mt-2" style="color: #FFFFFF; font-size: 24px;"></i>
                  </div>
                </div>
              </template>
          </div>

        </div>
      </div>

      <button v-show="!isAccelerate() && !me.lsa_cid && me.integrations.google_ads.status == 0 && (me.company_type == 'business' || me.company_type == 'location')" class="rounded bg-purple text-white text-bold text-xs focus:outline-none py-2 px-4 mr-5" @click="show_submit_lsa_cid = true">
          <i class="mdi mdi-alert" style="color: orange; font-size: 16px;"></i> SUBMIT LSA CID
      </button>

      <button v-show="!isAccelerate() && $store.state.auth.owner && me.company_type != 'admin' && me.company_type != 'agency'" class="rounded text-white text-bold text-xs focus:outline-none py-2 px-4 mr-5" @click="backToAgencyAdmin()" style="background: #c54e74 !important;">
          <i class="mdi mdi-arrow-left" style="color: white; font-size: 16px;"></i> Back to Agency
      </button>

      <button v-show="!isAccelerate() && $store.state.auth.admin && me.company_type != 'admin'" class="rounded text-white text-bold text-xs focus:outline-none py-2 px-4 mr-5" @click="backToAdmin()" style="background: #c54e74 !important;">
          <i class="mdi mdi-arrow-left" style="color: white; font-size: 16px;"></i> Back to Admin
      </button>

      <button v-show="!isAccelerate() && me.company_type == 'agency'" class="rounded text-white text-bold text-xs focus:outline-none py-2 px-4 mr-5" @click="show_locations_dd = false; $refs.dialogAddBusiness.show()" style="background: purple !important;">
          <i class="mdi mdi-plus" style="color: white; font-size: 16px;"></i> Add Business
      </button>
  
      <div style="position: relative;">

        <div class="flex" @click="toggleUserMenu()" style="cursor: pointer;">
          <a v-if="profile" class="me-icon mr-2 rounded-full text-white shadow-inner focus:outline-none zoom" style="width: 40px; display: block; text-align: center;">
            <div v-if="profile.profile_image">
              <img class="gravatar-pic" :src="profile.profile_image" />
            </div>
            <v-gravatar v-else class="gravatar-pic" :email="profile.email" default-img="https://lsaapi-uploads.s3.us-east-1.amazonaws.com/pics/default_profile.jpg" />
          </a>
          <div v-if="!$vuetify.breakpoint.mobile && profile" :style="((isAccelerate()) ? 'line-height: 20px;' : 'line-height: 16px;')">
            <span class="me-icon-name" :style="((isAccelerate()) ? '' : 'font-size: 12px !important;')">
              {{ profile.first_name }} {{ profile.last_name }}
            </span>
            <br />

            <div class="me-icon-email" :style="((isAccelerate()) ? '' : 'font-size: 12px !important;')">
              {{ profile.email }}
            </div>

            <div v-if="!isAccelerate()">
              <span class="me-icon-email" :style="((isAccelerate()) ? '' : 'font-size: 12px !important;')">
                {{ profile.company_name }}
              </span>

              <span v-if="me && me.integrations && me.integrations.bland && me.integrations.bland.status == 1" class="me-icon-email" style="font-size: 16px !important; font-weight: bold;">
                &nbsp;&nbsp;&nbsp; {{ me.integrations.bland.settings[0].phone_number }}
              </span>
            </div>
          </div>
          <div :class="(($vuetify.breakpoint.mobile) ? '' : 'ml-3')" style="line-height: 40px;">
            <i class="mdi mdi-chevron-down me-icon-icon"></i>
          </div>
        </div>
        <div v-if="showUserMenu" class="rounded-lg bg-white shadow-md absolute min-w-full mt-3 right-0 user-menu p-6" style="z-index: 99;">
          <div class="flex" style="cursor: pointer;">
            <a v-if="profile" class="me-icon mr-2 rounded-full text-white shadow-inner focus:outline-none zoom" style="width: 40px; display: block; text-align: center;">
              <div v-if="profile.profile_image">
                <img class="gravatar-pic" :src="profile.profile_image" />
              </div>
              <v-gravatar v-else class="gravatar-pic" :email="profile.email" default-img="https://lsaapi-uploads.s3.us-east-1.amazonaws.com/pics/default_profile.jpg" />
            </a>
            <div v-if="profile" style="line-height: 20px;">
              <span class="me-icon-name">
                {{ profile.first_name }} {{ profile.last_name }}
              </span>
              <br />

              <span class="me-icon-email">
                {{ profile.email }}
              </span>

              <div v-if="me && me.integrations && me.integrations.bland && me.integrations.bland.status" style="font-size: 12px; padding-top: 3px;">
                {{ me.integrations.bland.settings.phone_number }}
              </div>
            </div>
          </div>

          <v-divider v-if="lsa_licenses_top_nav && isAccelerate()" class="mt-3 mb-3"></v-divider>

          <div v-if="lsa_licenses_top_nav && isAccelerate()" class="flex" style="cursor: pointer; font-size: 11px;">
            <div style="padding-bottom: 5px; width: 50%;">
              <strong>License: </strong>

              <span v-if="lsa_licenses_top_nav.license.exists">
                <span v-if="lsa_licenses_top_nav.license.status == 'ACTIVE'">
                  <v-chip
                    v-if="lsa_licenses_top_nav.license.expiration_date"
                    x-small
                    color="orange lighten-5"
                    text-color="orange lighten-1"
                  >
                    EXPIRING
                  </v-chip>
                  <v-chip
                    v-else
                    x-small
                    color="green lighten-5"
                    text-color="green lighten-1"
                  >
                    ACTIVE
                  </v-chip>

                  <span v-if="lsa_licenses_top_nav.license.expiration_date"><strong>Expires:</strong> <span v-if="lsa_licenses_top_nav.license.expiration_date"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ formatDate(lsa_licenses_top_nav.license.expiration_date) }}</span><span v-else> Unknown</span></span>
                </span>

                <span v-else>
                  <v-chip
                    x-small
                    color="red lighten-5"
                    text-color="red lighten-1"
                  >
                    EXPIRED
                  </v-chip>
                </span>
              </span>
              <span v-else>
                <v-chip
                  x-small
                  color="gray darken-1"
                  text-color="gray"
                >
                  NONE
                </v-chip>
              </span>
            </div>

            <div style="padding-bottom: 5px; width: 50%;">
              <strong>Insurance: </strong>

              <span v-if="lsa_licenses_top_nav.insurance.exists">
                <span v-if="lsa_licenses_top_nav.insurance.status == 'ACTIVE'">
                  <v-chip
                    v-if="lsa_licenses_top_nav.insurance.expiration_date"
                    x-small
                    color="orange lighten-5"
                    text-color="orange lighten-1"
                  >
                    EXPIRING
                  </v-chip>
                  <v-chip
                    v-else
                    x-small
                    color="green lighten-5"
                    text-color="green lighten-1"
                  >
                    ACTIVE
                  </v-chip>

                  <span v-if="lsa_licenses_top_nav.insurance.expiration_date"><strong>Expires:</strong> <span v-if="lsa_licenses_top_nav.insurance.expiration_date"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ formatDate(lsa_licenses_top_nav.insurance.expiration_date) }}</span><span v-else> Unknown</span></span>
                </span>
                <span v-else>
                  <v-chip
                    x-small
                    color="red lighten-5"
                    text-color="red lighten-1"
                  >
                    EXPIRED
                  </v-chip>
                </span>
              </span>
              <span v-else>
                <v-chip
                  x-small
                  color="gray darken-1"
                  text-color="gray"
                >
                  NONE
                </v-chip>
              </span>
            </div>

          </div>

          <v-divider class="mt-3 mb-3"></v-divider>

            <ul class="me-icon-menu list-reset">
              <li><router-link :to="((me && me.company_type == 'agency') ? 'user-settings' : '/settings')" class="py-1 block"><i class="mdi mdi-account-outline mr-1" style="font-size: 16px;"></i> Edit Profile</router-link></li>
              <li v-if="shouldShowBilling()"><router-link to="/billing-settings" class="py-1 block"><i class="mdi mdi-credit-card-outline mr-1" style="font-size: 16px;"></i> Billing</router-link></li>
              <li v-if="!isAccelerate()"><router-link to="/support" class="py-1 block"><i class="mdi mdi-help-box-outline mr-1" style="font-size: 16px;"></i> Support</router-link></li>

              <li v-if="$store.state.auth.owner && me.company_type != 'admin' && me.company_type != 'agency'"><a href="javascript: void(0);" @click="backToAgencyAdmin()" class="py-1 block font-medium whitespace-no-wrap" style="color: #f56565 !important;"><i class="mdi mdi-arrow-left mr-1"></i> Back to Agency Dashboard</a></li>
              <li v-if="$store.state.auth.admin && me.company_type != 'admin'"><a href="javascript: void(0);" @click="backToAdmin()" class="py-1 block font-medium whitespace-no-wrap" style="color: #f56565 !important;"><i class="mdi mdi-arrow-left mr-1"></i> Back to Administration</a></li>

              <v-divider  class="mt-3 mb-3"></v-divider>
              <li><a href="#" class="py-1 block logout-link ml-1" @click="logout" style="font-size: 12px !important; font-weight: bold;"><i class="mdi mdi-logout mr-1"></i> Sign Out</a></li>
            </ul>
        </div>
      </div>
      
    </v-app-bar>

    <v-navigation-drawer 
      v-if="showHeaderAndNav"
      v-model="sidebarMenu" 
       class="rg-sidebar-left"
      app
      floating
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
      :width="250"
      >
      <v-list dense color="" dark>
          <v-list-item style="opacity: 1; margin: 0px !important; margin-left: 34px !important;">
              <v-list-item-content>
                  <v-list-item-title style="margin: 0px !important;">
                      <router-link to="/" class="" v-if="!$vuetify.breakpoint.mobile">
                        <span v-if="$agency" style="font-size: 12px; color: black;">
                          <img v-if="$agency.logo" :src="$agency.logo" alt="" style="height: 32px; display: inline-block;" />
                        </span>
                        
                        <span v-else>
                          <span v-if="!me.logo">
                            <img src="@/assets/lsa_icon.png" alt="" style="height: 32px; display: inline-block;">

                            LSA
                          </span>
                          <span v-else>
                            <span style="font-size: 12px; color: black;">
                              <img v-if="me.logo" :src="me.logo" alt="" style="height: 32px; display: inline-block;"> {{ me.company_name }}
                            </span>
                          </span>
                        </span>
                      </router-link>
                  </v-list-item-title>
              </v-list-item-content>
          </v-list-item>
      </v-list>

      <v-list class="-mt-4">
          <div v-if="me && me.company_type == 'admin'">
            <v-list-item v-for="item in menu_items.admin" :key="item.title" link :to="item.route" :href="item.href" :target="item.target">
                <v-list-item-icon style="padding-left: 26px; text-align: center;">
                    <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;" :style="(($vuetify.breakpoint.mobile) ? 'margin-left: 2px;' : '')"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </div>

          <div v-if="me && me.company_type == 'agency'">
            <span v-for="item in menu_items.agency" :key="item.title">
              <v-list-item link :to="item.route" :href="item.href" :target="item.target" v-if="displayNavigationItem(item)" :class="{ 'affiliate-nav-link': item.affiliate }">
                <v-list-item-icon style="padding-left: 26px; text-align: center;">
                    <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;" :style="(($vuetify.breakpoint.mobile) ? 'margin-left: 2px;' : '')"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ item.title }} <span v-if="item.affiliate" class="affiliate-new">NEW</span></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>
          </div>

          <template v-if="me && (me.company_type == 'business' || me.company_type == 'location')">
            <template v-for="item in menu_items.business">
              <span v-if="item.sub_nav" :key="item.title">
                <v-list-group
                  no-action
                  :key="item.title"
                >
                  <template v-slot:activator>
                    <v-list-item v-if="displayNavigationItem(item)" :sub-nav-parent="item.route"
                    >
                      <v-list-item-icon style="padding-left: 11px; text-align: center;" @click="$router.push(item.sub_nav[0].route).catch(()=>{});">
                          <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;" :style="(($vuetify.breakpoint.mobile) ? 'margin-left: 2px;' : '')"></i>
                      </v-list-item-icon>
                      <v-list-item-content @click="$router.push(item.sub_nav[0].route).catch(()=>{});">
                          <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-for="(child, index) in item.sub_nav"
                    :key="index"
                    link
                    :to="child.route"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="color: #FFFFFF; font-size: 12px;"
                        :style="(($router.currentRoute.path == child.route) ? 'opacity: 1;' : 'opacity: 0.5')"
                      >
                        <div style="float: left; border-radius: 10px; background: #4EC5A1; width: 10px; height: 10px; margin-top: 3px; margin-right: 10px; margin-left: 65px;"></div>
                        {{ child.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  
                </v-list-group>
              </span>
              <span v-else :key="item.section">
                <v-list-item link :to="item.route" :href="item.href" :target="item.target" v-if="displayNavigationItem(item)">
                  <v-list-item-icon style="padding-left: 26px; text-align: center;">
                      <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;" :style="(($vuetify.breakpoint.mobile) ? 'margin-left: 2px;' : '')"></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </span>
            </template>

            <template v-if="$agency && $agency.settings.members_area_enabled">
              <span>
                <v-list-item :to="'/members-area'"
                  >
                  <v-list-item-icon style="padding-left: 26px; text-align: center;">
                      <i class="mdi mdi-wallet-membership" style="color: white; font-size: 20px; margin-top: -3px;" :style="(($vuetify.breakpoint.mobile) ? 'margin-left: 2px;' : '')"></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title class="white--text">{{ $agency.settings.members_area_nav_text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </span>
            </template>

            <!-- <span v-if="hasGridTrackerEnabled()">
              <v-list-item :to="'/grid-tracker-list'">
                <v-list-item-icon style="padding-left: 26px; text-align: center;">
                    <i class="mdi mdi-map-marker-multiple-outline" style="color: white; font-size: 20px; margin-top: -3px;" :style="(($vuetify.breakpoint.mobile) ? 'margin-left: 2px;' : '')"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="white--text">Grid Tracker</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span> -->
          </template>
      </v-list>
  </v-navigation-drawer>

  <div v-if="!showHeaderAndNav" style="height: 100%;">
    <div v-if="hasAccess" style="height: 100%;">
      <agency-number-approval-notice v-if="me && me.status == 1" />
      <slot v-if="me && me.status == 1"></slot>
      <div v-if="me && me.status == 0" class="">
        Your access has been disabled. Please contact your account owner.
      </div>
    </div>
    
    <div v-if="me && !hasAccess">
        You do not have access to this section. In order to get access, please contact your account manager.
      </div>
  </div>

  <v-container v-else class="rg-container fill-height" fluid :style="((inbox == true && hasAccess) ? 'padding: 0px !important; margin: 0px !important;' : 'padding: 40px;')">
      <v-row class="fill-height">
          <v-col>
              <div v-if="hasAccess" class="h-full">
                <agency-number-approval-notice v-if="me && me.status == 1" />
                <slot v-if="me && me.status == 1"></slot>
                <div v-if="me && me.status == 0" class="">
                  Your access has been disabled. Please contact your account owner.
                </div>
              </div>
              
              <div v-if="me && !hasAccess">
                  You do not have access to this section. In order to get access, please contact your account manager.
                </div>
          </v-col>
      </v-row>
  </v-container>

  <account-assistants v-if="showHeaderAndNav && hasAccess && me && me.status == 1" :account="me" />

  </div>



</template>

<script>
import AgencyNumberApprovalNotice from './AgencyNumberApprovalNotice.vue'

import $ from 'jquery'
import axios from 'axios'
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway';
import dialogAddBusiness from '@/components/dialogs/businesses/addBusiness.vue'
import moment from 'moment'
import ProductAccessRequired from '@/components/reusable/ProductAccessRequired.vue'
import AccountAssistants from '@/components/AccountAssistants.vue'

function normalizeBusinessMenuItems(stored) {
  // Drop retired/cached links and keep a single tutorial link at the end.
  const excluded = ['/onboarding', '/competitor-intel', '/videos'];
  const items = Array.isArray(stored) ? stored.filter(item => item && !excluded.includes(item.route) && !excluded.includes(item.section)) : [];
  return items.concat({ title: 'Video Tutorials', section: '/videos', route: '/videos', icon: 'mdi mdi-play-circle-outline', only_owner: false });
}

function cachedBusinessMenuItems() {
  try {
    const stored = JSON.parse(localStorage.getItem('businessMenuItems') || '[]');
    const items = normalizeBusinessMenuItems(stored);
    localStorage.setItem('businessMenuItems', JSON.stringify(items));
    return items;
  } catch (e) {
    return normalizeBusinessMenuItems([]);
  }
}


export default {
  mixins: [ clickaway ],

  props: ['inbox'],

  data: function() {
    return {
      show_locations_dd: false,

      showUserMenu: false,
      loaded: false,
      locations_links_visible: false,
      locations_links_done: false,

      drawer: false,
      group: null,

      search_locations: "",
      filtered_locations: [],

      sidebarMenu: true,
      toggleMini: false,
      menu_items: {
        admin: [
          { title:"Agency approvals", route:"/agency-approvals", icon:"mdi mdi-account-check-outline" },
          { title:"Dashboard", route:"/dashboard", icon: "mdi mdi-view-dashboard-outline" },
          { title:"Agencies", route:"/agencies", icon: "mdi mdi-briefcase-outline" }
        ],
        agency: [
          { title:"Agency approvals", route:"/agency-approvals", icon:"mdi mdi-account-check-outline", approvals: true },
          { title:"Dashboard", section: '/dashboard', route:"/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
          { title:"Agencies", route:"/agencies", icon: "mdi mdi-briefcase-variant-outline" },
          // { title:"Turbo Settings", route:"/turbo-outbound", icon: "mdi mdi-call-made" },
          { title:"Businesses", section: '/businesses', route:"/businesses", icon: "mdi mdi-briefcase-outline", only_owner: false },
          { title:"Admin", section: '/ai-admin', route:"/ai-admin", icon: "mdi mdi-airballoon-outline", only_owner: false },
          // { title:"Sales Resources", section: '/resources', route:"/resources", icon: "mdi mdi-text-box-outline", only_owner: false },
          { title:"Audits", section: '/local-recon', route:"/local-recon/dashboard", icon: "mdi mdi-web", only_owner: false },
          // { title:"LSA Health", section: '/lsa-health-command-center', route:"/lsa-health-command-center", icon: "mdi mdi-heart-pulse", only_owner: false },
          { title:"Reviews", section: "/reviews", "route": "/reviews", icon: "mdi mdi-calendar-star-outline", only_owner: false },
          { title:"Users", section: '/users', route:"/users", icon: "mdi mdi-account-multiple", only_owner: true },
          { title:"Reports", section: '/reports', route:"/reports", icon: "mdi mdi-chart-bar", only_owner: false },
          { title:"Settings", section: '/agency-settings', route:"/agency-settings", icon: "mdi mdi-cog-outline", only_owner: false },
          { title:"Video Tutorials", section: "/videos", route: "/videos", icon: "mdi mdi-play-circle-outline", only_owner: false },
          { title:"Refer & Earn", route:"/refer-and-earn", icon:"mdi mdi-gift-outline", affiliate: true },
          { title:"Usage", section: '/usage', route:"/usage", icon: "mdi mdi-currency-usd", only_owner: false },
          // { title: "Roadmap", section: "/roadmap", route: "/roadmap", icon: "mdi mdi-chart-timeline", only_owner: false },
          // { title:"Help", section: '/help', href:"javascript: document.querySelector('#gs button .gs13').click()", icon: "mdi mdi-help-circle-outline", only_owner: false },
        ],
        business: cachedBusinessMenuItems()
      },

      licenses: [],
      lsa_licenses_top_nav: null,

      show_submit_lsa_cid: false,
      lsa_cid: ""
    }
  },
  components: {
    AgencyNumberApprovalNotice,
    dialogAddBusiness,
    ProductAccessRequired,
    AccountAssistants
  },
  methods: {
    saveLsaCid() {
      this.me.lsa_cid = this.lsa_cid;

      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/submit-lsa-cid`, {
        lsa_cid: this.lsa_cid
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$swal({
        title: "Request Sent!",
        text: "We have submitted a request for access to your CID. The request will come from company named Accelererate Marketing. Once approved, we will start submitting your surveys and Google LSA notes in order to get more refunds and improve your lead quality!",
        showCancelButton: false,
      });
    },

    buildBusinessMenuItems() {
      // console.log('this.isAccelerate()', this.isAccelerate());
      if (this.isOnlyAi() && !this.isAccelerate()) {
        this.menu_items.business = [
          { title: "Dashboard", section: "/dashboard", "route": "/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
          { title: "AI Agent", section: "/ai-agent", "route": "/ai-agent", icon: "mdi mdi-robot", only_owner: false },
          // { title: "LSA Health", section: "/lsa-health-command-center", "route": "/lsa-health-command-center", icon: "mdi mdi-heart-pulse", only_owner: false },
          { title: "Settings", section: "/settings/settings", route: "/settings", icon: "mdi mdi-cog-outline", only_owner: false,
            sub_nav: [
              { title: "General", section: "/settings/settings", "route": "/settings/settings", icon: "mdi mdi-cog-outline", only_owner: false },
              { title: "Reviews", section: "/settings/reviews", "route": "/settings/reviews", icon: "mdi mdi-calendar-star-outline", only_owner: false },
              // { title: "GBP Manager", section: "/settings/gbp", "route": "/settings/gbp", icon: "mdi mdi-google-maps", only_owner: false },
              { title: "Refunds", section: "/settings/refunds", "route": "/settings/refunds", icon: "mdi mdi-cash-refund", only_owner: false },
              { title: "Radius", section: "/settings/Radius", "route": "/settings/Radius", icon: "mdi mdi-radius-outline", only_owner: false },
            ]
           }
        ];
      }
      else if (!this.isAccelerate()) {
        this.menu_items.business = [
          { title: "Dashboard", section: "/dashboard", "route": "/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
          { title: "AI Agent", section: "/ai-agent", "route": "/ai-agent", icon: "mdi mdi-robot", only_owner: false },
          // { title: "LSA Health", section: "/lsa-health-command-center", "route": "/lsa-health-command-center", icon: "mdi mdi-heart-pulse", only_owner: false },
          { title:"LSA Audit", section: '/lsa-audit', route:"/lsa-audit", icon: "mdi mdi-web", only_owner: false },
          { title: "Rank Tracker", section: "/rank-tracker", route: "/rank-tracker", icon: "mdi mdi-map-marker-path", only_owner: false },
          { title: "Settings", section: "/settings/settings", route: "/settings", icon: "mdi mdi-cog-outline", only_owner: false,
            sub_nav: [
              { title: "General", section: "/settings/settings", "route": "/settings/settings", icon: "mdi mdi-cog-outline", only_owner: false },
              { title: "Reviews", section: "/settings/reviews", "route": "/settings/reviews", icon: "mdi mdi-calendar-star-outline", only_owner: false },
              { title: "GBP Manager", section: "/settings/gbp", "route": "/settings/gbp", icon: "mdi mdi-google-maps", only_owner: false },
              { title: "Refunds", section: "/settings/refunds", "route": "/settings/refunds", icon: "mdi mdi-cash-refund", only_owner: false },
              { title: "Radius", section: "/settings/Radius", "route": "/settings/Radius", icon: "mdi mdi-radius-outline", only_owner: false },
            ]
           }
        ];
      }
      else {
        this.menu_items.business = [
          { title: "Dashboard", section: "/dashboard", "route": "/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
          { title: "AI Agent", section: "/ai-agent", "route": "/ai-agent", icon: "mdi mdi-robot", only_owner: false },
          // { title: "LSA Health", section: "/lsa-health-command-center", "route": "/lsa-health-command-center", icon: "mdi mdi-heart-pulse", only_owner: false },
          { title: "Leads", section: "/leads", "route": "/leads", icon: "mdi mdi-account-filter", only_owner: false },
          { title: "Local SEO", section: "/leads-seo", "route": "/leads-seo", icon: "mdi mdi-search-web", only_owner: false },
          { title: "Reviews", section: "/reviews", "route": "/reviews", icon: "mdi mdi-calendar-star-outline", only_owner: false },
          { title: "GBP Manager", section: "/settings/gbp", "route": "/settings/gbp", icon: "mdi mdi-google-maps", only_owner: false },
          { title:"LSA Audit", section: '/lsa-audit', route:"/lsa-audit", icon: "mdi mdi-web", only_owner: false },
          { title: "Settings", section: "/settings", route: "/settings", icon: "mdi mdi-cog-outline", only_owner: false }
        ];
      }

      this.menu_items.business = normalizeBusinessMenuItems(this.menu_items.business);
      localStorage.setItem("businessMenuItems", JSON.stringify(this.menu_items.business));
    },

    isOnlyAi() {
      if (this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.status == 0)
        return true;

      return false;
    },

    formatDate: function(date, format = "MM/DD/YYYY") {
      // console.log('date', date);
      return moment(String(date)).format(format)
    },

    async getLicenses() {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-lsa-licenses`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.licenses = response.data.licenses;
      this.lsa_licenses_top_nav = response.data.lsa_licenses_top_nav;
    },

    clickedOutsideLocationsDd() {
      this.show_locations_dd = false;
      this.search_locations = "";
      this.calculateFilteredLocations();
    },

    showLocationsDd() {
      let self = this;
      setTimeout(function() { self.show_locations_dd = true }, 100);
    },

    toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;      
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
    },
    async logout() {
      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/add-activity`, {
        activity: "Logged out."
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let email = this.me.email
      try {
        await this.$store.dispatch('auth/logout')
        this.$router.push('/')

      } catch (e) {
        // console.log(e)
      }
    },
    async switchLocation(email) {
      this.$store.me = null;
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-child-jwt-token?email=${email}`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (this.me.company_type == "admin") {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&admin=true&admin_jwt_token=" + btoa(this.$store.state.auth.jwt);
        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), admin: true, admin_jwt_token: btoa(this.$store.state.auth.jwt) }});
      }
      else if (this.me.company_type == "agency") {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&owner=true&owner_jwt_token=" + btoa(this.$store.state.auth.jwt);
        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt) }});
      }
      else {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token);

        // if (this.profile.company_type == 'user')
        //   this.$store.state.business_user = this.profile;

        // this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token) }});

        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token) }});
      }
    },
    backToAdmin() {
      let self = this
      this.$store.state.auth.owner = false
      this.$store.state.auth.admin = false

      setTimeout(function() {
        // window.location = window.location.origin + '/login?alt=' + self.$store.state.auth.admin_jwt_token;
        self.$router.push({ name: 'login', query: {alt: self.$store.state.auth.admin_jwt_token }});
      }, 10);
    },
    backToAgencyAdmin() {
      let self = this
      this.$store.state.auth.owner = false

      setTimeout(function() {
        self.$router.push({ name: 'login', query: {alt: self.$store.state.auth.owner_jwt_token }});
        // window.location = window.location.origin + '/login?alt=' + self.$store.state.auth.owner_jwt_token;
      }, 1000);
    },
    clickedOutsideUserMenu() {
      this.showUserMenu = false
    },
    checkLocationsLinksDone() {
      let self = this
      if (!this.locations_links_done) {
        setTimeout(function() {
          try {
            var content = document.getElementsByClassName('locations-links')[0];
            var body = document.getElementsByClassName('v-select-list')[0];
            content.parentNode.removeChild(content);
            body.prepend(content);
            self.locations_links_done = true
          }
          catch (e) {}
        }, 50);
      }
    },
    commafy: function( num ) {
      var str = num.toString().split('.');
      if (str[0].length >= 5) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      }
      if (str[1] && str[1].length >= 5) {
          str[1] = str[1].replace(/(\d{3})/g, '$1 ');
      }
      return str.join('.');
    },
    getCreditsAvailable() {
      let available_credits = this.me.credits_monthly + this.me.credits_extra - this.me.credits_used

      if (available_credits < 0)
        return "Unlimited"

      return this.commafy(available_credits)
    },
    sectionEnabled(section) {
      return true;
      try {
        let sections = JSON.parse(this.profile.settings.sections);

        if (typeof(sections[section]) == "undefined") {
          return true;
        }
        
        if (!sections[section]) {
          return false;
        }
      }
      catch(e) {
      }


      return true;
    },
    displayNavigationItem(item) {
      if (item.approvals) return this.me && this.me.company_type === 'agency' && Number(this.me.id) === 1353;
      if (item.affiliate) return Number(this.me.parent_id) === 1353 && this.profile.company_type === 'agency';

      if (item.title == "Local SEO") {
        if (this.me.local_seo_tab || this.me.brightlocal_report_url) {
          return true;
        }
        else {
          return false;
        }
      }

      if (this.me.id != 1353 && (item.title == "Usage")) {
        return false;
      }

      if (this.me.id != 909 && this.me.id != 1353 && (item.title == "Agencies" || item.title == "Turbo Settings")) {
        return false;
      }

      return true;

      if (this.$store.state.auth.owner || this.$store.state.auth.admin)
        return true;

      if (item.only_owner) {
        if (this.profile.company_type == 'user') {
          return false;
        }
        else {
          return true;
        }
      }

      if (!this.me.subscription)
        return false;
      
      if (this.me.subscription.product_details.limits.hide_sections === true && !this.me.subscription.product_details.limits.permissions[item.route])
        return false;

      if (this.profile.company_type == 'user') {
        return this.sectionEnabled(item.section);
      }

      return true;
    },
    hasGridTrackerEnabled() {
      return true;
      try {
        return this.me.subscription.product_details.limits.grid_tracker_enabled;
      }
      catch (e) {}

      return false;
    },
    getHost() {
      return window.location.host;
    },

    isAccelerate() {
       // || this.getHost() == 'localhost:8080'
      return this.getHost() == 'lsa.accelerateyourmarketing.com';
      //  || this.getHost() == 'organic-train-7vqj4qq9x9hrgp5-8080.app.github.dev';
    },
    shouldShowBilling() {
      return false;
      return this.me.company_type == 'business' && !this.isAccelerate();

      return this.me.company_type == 'business' && this.me.free_user && (window.location.host == 'app.conversationalagency.ai' || window.location.host == 'app.diyai.ai');

      return true;

      if (localStorage.getItem("business_user")) {
        return false;
      }

      return (this.profile.company_type == 'agency' || (this.me.company_type == 'business' && this.me.parent_id && this.me.subscription));
    },

    async refetchMe() {
      await this.$store.dispatch('me/fetch')
    },

    calculateFilteredLocations() {
        this.filtered_locations = [];

        for (var i in this.locations) {
          // console.log(this.locations[i].name);
          if (this.search_locations) {
            if (this.locations[i].name.toLowerCase().indexOf(this.search_locations.toLowerCase()) != -1 || this.locations[i].business_name.toLowerCase().indexOf(this.search_locations.toLowerCase()) != -1) {
              this.filtered_locations.push(this.locations[i]);
            }
          }
          else {
            this.filtered_locations.push(this.locations[i]);
          }
        }
    },

    async fetchMeStatsLocations() {
      await this.$store.dispatch('locations/fetch')

      this.calculateFilteredLocations();
      
      if (!this.me)
        await this.$store.dispatch('me/fetch')

      this.buildBusinessMenuItems();

      // console.log('unu');
      if (this.me.free_user == 1) {
        // console.log('doi');
        if (this.me.message_usage >= 20 && this.me.voice_usage >= 6 && 0) {
          // console.log('trei');
          this.$swal({
            icon: 'warning',
            title: "Usage depleted",
            html: "You have used your free credits for both voice and message AI leads. Please setup a discovery call in order to activate your account. <div style='padding-top: 20px;'><a href='https://api.leadconnectorhq.com/widget/bookings/general-ryan/lsa-and-ai-software-demo' style='color: blue;'>Click here to setup call</a></div>",
            showCancelButton: false, // There won't be any cancel button
            showConfirmButton: false, // There won't be any confirm button
            allowOutsideClick: false // There won't be any ability to close the box
            // confirmButtonText: 'OK'
          }).then(function() {
  
          });
        }
      }

      await this.$store.dispatch('stats/fetch')

      // console.log('this locations', this.locations)

      if (this.me.company_type != 'agency' && this.me.company_type != 'admin') {
        let locationFound = false;
        for (var i in this.locations) {
          if (this.me.uuid == this.locations[i].value) {
            locationFound = true;
          }
        }

        if (!locationFound) {
          this.switchLocation(this.locations[0].value);
        }
      }
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
      fetchingLocations: state => state.locations.fetchingLocations,
      locations: state => state.locations.locations,
      stats: state => state.stats.stats,
      fetchingStats: state => state.stats.fetchingStats,
      showHeaderAndNav: function() {
        if (this.$router.currentRoute.name == 'local_recon_widgets_create')
          return false;

        if (this.$router.currentRoute.name == 'local_recon_widgets_edit')
          return false;

        if (this.$router.currentRoute.name == 'local_recon_widgets_edit_token')
          return false;


        
        if (this.$router.currentRoute.name == 'widgets_create')
          return false;
        
        if (this.$router.currentRoute.name == 'widgets_edit')
          return false;
        
        if (this.$router.currentRoute.name == 'widgets_edit_token')
          return false;
        
        if (this.$router.currentRoute.name == 'AIAgent')
          return false;

        return true;
      }
    }),
    mini() {
        return (this.$vuetify.breakpoint.smAndDown) || this.toggleMini
    },
    buttonText() {
        return !this.$vuetify.theme.dark ? 'Go Dark' : 'Go Light'
    },
    hasAccess() {
      return true;
      if (this.me.company_type != 'agency') {
        if (window.location.pathname == '/plans') {
          this.$router.push('/');
          return false;
        }
      }

      // console.log('this.me.subscription.product_details.limits.permissions', this.me.subscription.product_details.limits.permissions)

      return this.me && (
        this.me.company_type == "admin" ||
        this.me.company_type == "agency" ||
        this.$store.state.auth.owner || 
        this.$store.state.auth.admin || 
        (
          (
            !this.me.subscription.product_details.limits.permissions.hasOwnProperty(window.location.pathname) || 
            this.me.subscription.product_details.limits.permissions[window.location.pathname])
          )
        );
    },


  },
  mounted() {
    this.fetchMeStatsLocations();

    // console.log(this.$store.state)
    
    let thisRoutePath = this.$router.currentRoute.path;

    let exploded = thisRoutePath.split('/');

    if (exploded.length > 0) {
      tryOpening();

      function tryOpening() {
        let aEl = $('div.v-list-item[sub-nav-parent="/' + exploded[1] + '"]');
        if (aEl.length > 0)
          aEl.click();
        else {
          setTimeout(function() {
            tryOpening();
          }, 50);
        }
      }
    }

    if (!this.isAccelerate()) {
      if (this.me && this.me.company_type != 'agency')
        this.getLicenses();


    }
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
}
</script>

<style lang="css" scoped>
.v-navigation-drawer__content a {
  text-decoration: none;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 20px;
}

.mx-auto.v-card, .v-list-item {
  height: 56px;
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.menu .router-link-exact-active {
  color: white !important;
}

.v-application ul, .v-application ol {
  padding-left: 0px;
}

.menu a {
  color: #c6f6d5;
}

.user-menu li i {
  width: 24px;
}

.locations-dropdown {
  width: 500px;
}

.header-right-items {
  float: left; margin-top: -31px; padding-right: 10px;
}

.mobile-navigation {
  /* position: absolute; */
  /* width: 255px;
  height: 100%; */
  /* display: none; */
  /* right: 0px; */
  /* margin-top: -20px; */
}

.mobile-navigation .v-btn__content i {
  font-size: 40px;
}

.mobile-navigation a {
  color: #757575;
  font-size: 15px;
  width: 100%;
  display: block;
  font-weight: bold;
}

.mobile-navigation a i {
  /* margin-right: 5px; */
  width: 24px;
}

@media screen and (max-width: 1023px) {
  .locations-dropdown {
    width: 275px;
  }
}

@media screen and (max-width: 767px) {
  .header-right-part {
    width: 100%;
  }
  .header-right-items {
    width: calc(100% - 37px);
  }
  .locations-dropdown {
    width: 100%;
  }
  .header-stats {
    display: none;
  }
  /* .me-icon {
    margin-top: 20px;
  } */

  .desktop-navigation {
    display: none;
  }

  .mobile-navigation {
    display: block;
  }

  .container {
    max-width: 100% !important;
  }
}

.user-menu {
  min-width: 300px !important;
}

.locations-links {
  /* padding-right: 20px; */
  text-align: right;
  /* margin-top: 4px; */
  z-index: 9;
  margin-bottom: 5px;
}

.locations-links {
  font-size: 12px;
}

.locations-links a {
  color: #1976d2;
}

.header-stats {
  color: #828282;
  margin-bottom: 6px;
  text-align: right;
}

.gravatar-pic {
  border-radius: 50%;
}

@media screen and (max-width: 900px) {
  .v-list-item__icon {
    padding-left: 0px !important;
  }
}

.rg-sub-nav {

}
</style>

<style scoped>
.rg-sidebar-left .v-list-item.affiliate-nav-link { background: #575aa5 !important; color: #fff !important; border-left: 3px solid #b7b9ef; }
.rg-sidebar-left .v-list-item.affiliate-nav-link .v-list-item__title,
.rg-sidebar-left .v-list-item.affiliate-nav-link i { color: #fff !important; }
.affiliate-nav-link .v-list-item__icon { align-self: center; align-items: center; }
.affiliate-nav-link .v-list-item__title { display: flex; align-items: center; gap: 8px; }
.affiliate-new { font-size: 9px; line-height: 16px; font-weight: 700; letter-spacing: .04em; color: #fff; background: #3b3d7a; padding: 0 5px; border-radius: 3px; }
</style>
